import { defineMessages } from 'react-intl';

export const rateSortMenuMessages = defineMessages({
  sortByLabel: {
    defaultMessage: 'Sort by:',
    id: 'W/QSa1',
    description: 'Heading of the dropdown that sorts the list of freight rate carriers',
  },
  sortAriaLabel: {
    defaultMessage: 'Sort rates',
    id: 'vZyT8Z',
    description: 'Aria label for the icon button that opens the freight rate sort dropdown',
  },
  priceAscending: {
    defaultMessage: 'Price: Low to high',
    id: '0S6p/3',
    description: 'Freight rate sort option ordering carriers from cheapest to most expensive',
  },
  priceDescending: {
    defaultMessage: 'Price: High to low',
    id: '1QnUfB',
    description: 'Freight rate sort option ordering carriers from most expensive to cheapest',
  },
  transitAscending: {
    defaultMessage: 'Est Delivery Time: Low to high',
    id: 'QZwD/K',
    description: 'Freight rate sort option ordering carriers from fastest to slowest transit time',
  },
  transitDescending: {
    defaultMessage: 'Est Delivery Time: High to low',
    id: 'SvAmsk',
    description: 'Freight rate sort option ordering carriers from slowest to fastest transit time',
  },
});
